var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language-switcher",class:{'language-switcher--expanded' : _vm.expanded}},[_c('button',{staticClass:"language-switcher__button",on:{"click":_vm.expand}},[_vm._t("icon")],2),_vm._t("list")],2)}
var staticRenderFns = []

export { render, staticRenderFns }